import { ErrorComponent } from "@/components/common/errors";
import { Spinner } from "@/components/common/svgs";

import { TruckListEmptyState } from "./TruckListEmptyState";
import { TruckListRow } from "./TruckListRow";
import { TruckListTableHeader } from "./TruckListTableHeader";

const COLUMN_COUNT = 8;

// Relative widths for the 8 columns (Age → Note), used with table-fixed layout.
const COLUMN_WIDTHS = ["8%", "11%", "12%", "14%", "12%", "14%", "16%", "13%"];

// Bordered card holding the toolbar and the truck table, including its
// loading, error and empty states.
export const TruckListTable = ({ toolbar, trucks, loading, error, sort, onSort, locationSortKey }) => (
    <div className="overflow-hidden rounded-lg border border-cm-p-outline bg-cm-p-surface">
        {toolbar}
        <div className="overflow-x-auto">
            <table className="w-full min-w-[960px] table-fixed border-spacing-0">
                <colgroup>
                    {COLUMN_WIDTHS.map((width, index) => (
                        <col key={index} style={{ width }} />
                    ))}
                </colgroup>
                <TruckListTableHeader sort={sort} onSort={onSort} locationSortKey={locationSortKey} />
                <tbody>
                    {loading ? (
                        <tr>
                            <td colSpan={COLUMN_COUNT}>
                                <div className="flex justify-center py-16">
                                    <Spinner className="h-8 w-8 text-cm-p-accent" />
                                </div>
                            </td>
                        </tr>
                    ) : error ? (
                        <tr>
                            <td colSpan={COLUMN_COUNT}>
                                <ErrorComponent className="min-h-[220px]" />
                            </td>
                        </tr>
                    ) : trucks.length === 0 ? (
                        <tr>
                            <td colSpan={COLUMN_COUNT}>
                                <TruckListEmptyState />
                            </td>
                        </tr>
                    ) : (
                        trucks.map((truck) => <TruckListRow key={truck.id} truck={truck} />)
                    )}
                </tbody>
            </table>
        </div>
    </div>
);
